export default "__VITE_ASSET__Cz_FGu6O__"